import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

export const RowMessage: FC<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ children, ...props }) => {
  const { cnBem } = useAuthPageWrapperContext();

  return (
    <div {...props} className={cnBem('__rowMessage')}>
      {children}
    </div>
  );
};
